import React, { useEffect, useState } from "react";
import { TitleBar } from "../../Components/Common/TitleBar/titleBar";
import {
  Button,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Spinner,
  Table,
  Toast,
  ToastBody,
  ToastHeader,
} from "reactstrap";
import "./style/index.scss";
import { TripModal } from "../../Components/Common/TripModal/tripModal";
import DeleteModal from "../../Components/Common/DeleteModal";
import { useNavigate } from "react-router-dom";
import { Pagination } from "../../Components/Common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import {
  deleteRole,
  getAllRoleList,
  getRoleById,
} from "../../slices/rolesAndPermission/thunk";
import {
  hideErrorMessage,
  loadingData,
} from "../../slices/rolesAndPermission/reducer";

const UserPermissions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getRoles = useSelector((state) => state.Roles.rolesList);
  console.log(getRoles, "getRoles");

  const roleById = useSelector((state) => state.Roles.roleById);

  const loading = useSelector((state) => state.Roles.loading);

  const [viewDetails, setViewDetails] = useState(false);
  const [deleteRoleModal, setDeleteRoleModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [toasterType, setToasterType] = useState("success");

  const showToaster = (isSuccess, message) => {
    setShowToast(true);
    setToasterType(isSuccess ? "success" : "danger");
    setToastMessage(message);
    setTimeout(() => {
      setShowToast(false);
      if (!isSuccess) {
        dispatch(hideErrorMessage());
      }
      navigate("/user-permissions");
    }, 3000);
  };

  const toggleViewDetailModal = async () => {
    setViewDetails(!viewDetails);
  };

  const toggleDeleteRoleModal = () => {
    setDeleteRoleModal(!deleteRoleModal);
  };

  const handleDelete = async () => {
    try {
      const response = await dispatch(deleteRole(roleById.id));
      const { success, message } = response;
      showToaster(success, message);
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors || "Failed to delete role";
      showToaster(false, errorMessage);
      dispatch(hideErrorMessage());
    } finally {
      await dispatch(getAllRoleList(currentPage, pageSize, searchText));
      await toggleDeleteRoleModal();
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      try {
        dispatch(getAllRoleList(currentPage, pageSize, searchText));
      } catch (error) { }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [dispatch, currentPage, pageSize, searchText]);

  document.title = "Roles and  Permissions | D&A";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex flex-column gap-4">
            <TitleBar title={"User Access & Permissions"} />

            <div className="permissionSection">
              <div className="d-flex flex-column-reverse flex-lg-row justify-content-end align-items-end p-2 p-lg-0 gap-1 gap-lg-0">
                <InputGroup className="search-input">
                  <InputGroupText>
                    <i className="ri-search-line" />
                  </InputGroupText>
                  <Input
                    type="text"
                    placeholder="Search input text"
                    value={searchText}
                    disabled={getRoles.count === 0}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        dispatch(getAllRoleList(1, pageSize, searchText));
                        setCurrentPage(1);
                      }
                    }}
                  />
                </InputGroup>
                <Button
                  onClick={() => navigate("/add-permissions")}
                  className="newPermissionBtn"
                >
                  Add Roles <i className="ri-add-line" />
                </Button>
              </div>

              <div
                className="position-fixed top-0 end-0 p-3"
                style={{ zIndex: 1055 }}
              >
                <Toast isOpen={showToast}>
                  <ToastHeader
                    icon={toasterType === "danger" ? "danger" : "success"}
                    toggle={() => setShowToast(false)}
                  >
                    {toasterType === "danger" ? "Error" : "Success"}
                  </ToastHeader>
                  <ToastBody>{toastMessage}</ToastBody>
                </Toast>
              </div>

              <div className="trip-table">
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Roles</th>
                      <th>Permissions</th>
                      <th>Created By </th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {loading.read ? (
                    <tbody>
                      <tr>
                        <td colSpan="8" className="text-center align-middle">
                          <Spinner color="primary" />
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {getRoles?.results?.length ? (
                        getRoles?.results?.map((element, index) => (
                          <tr key={index}>
                            <td>{(currentPage - 1) * pageSize + index + 1}</td>
                            <td>{element.name}</td>
                            <td>
                              <ul>
                                {element?.permissions?.length > 0 ? (
                                  Object.entries(
                                    element.permissions.reduce((acc, curr) => {
                                      const [entity, action] =
                                        curr.name.split(/_(?=[^_]+$)/);
                                      if (!acc[entity]) acc[entity] = [];
                                      acc[entity].push(action);
                                      return acc;
                                    }, {})
                                  ).map(([entity, actions]) => (
                                    <li key={entity}>
                                      {entity
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (char) =>
                                          char.toUpperCase()
                                        )}
                                      :{" "}
                                      {actions
                                        .map(
                                          (action) =>
                                            action.charAt(0).toUpperCase() +
                                            action.slice(1).toLowerCase()
                                        )
                                        .join(", ")}
                                    </li>
                                  ))
                                ) : (
                                  <li>No permissions</li>
                                )}
                              </ul>
                            </td>
                            <td>{element?.created_by?.split(" - ")[0]}</td>
                            <td>
                              {" "}
                              {moment(element?.created_at).format("D MMM YYYY")}
                            </td>

                            <td>
                              <div className="action-icons">
                                <i
                                  className="ri-eye-fill icon"
                                  style={{ color: "#E8A014" }}
                                  onClick={() => {
                                    toggleViewDetailModal();
                                    dispatch(getRoleById(element.id));
                                    dispatch(
                                      loadingData({
                                        type: "read",
                                        value: false,
                                      })
                                    );
                                  }}
                                />
                                <i
                                  className="ri-pencil-fill icon"
                                  style={{ color: "#007AFF" }}
                                  onClick={() => (
                                    navigate(`/add-permissions/${element.id}`),
                                    dispatch(
                                      loadingData({
                                        type: "read",
                                        value: false,
                                      })
                                    )
                                  )}
                                />
                                <i
                                  className="ri-delete-bin-fill icon"
                                  style={{ color: "#FB0000" }}
                                  onClick={() => {
                                    dispatch(getRoleById(element.id));
                                    toggleDeleteRoleModal();
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="text-start text-sm-center" colSpan={7}>
                            <h3>No Roles Found</h3>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </Table>
              </div>
              {getRoles?.results?.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  totalItems={getRoles?.count || 0}
                />
              )}
            </div>
          </div>

          <TripModal
            isModalOpen={viewDetails}
            toggleModal={toggleViewDetailModal}
            buttonText="Assign"
            size="lg"
            closeText={"Close without saving"}
            title={"User Roles and Permissions"}
            tripText={"User Roles and Permissions"}
            showButtons={false}
            showDeleteIcon={false}
            showEditIcon={false}
            showcloseIcon={true}
            editIconClick={() => navigate(`/add-permissions/${roleById.id}`)}
            loading={loading.getById}
            deleteIconClick={() => {
              toggleViewDetailModal();
              dispatch(getRoleById(roleById.id));
              toggleDeleteRoleModal();
            }}
          >
            <div className="px-3 d-flex flex-column gap-4">
              <Row className="mb-5">
                <div className="permission-custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="permissionLabel">
                      Role<span className="d-md-none">:</span>
                    </span>
                    <span className="permissionValue">{roleById?.name}</span>
                  </div>
                </div>
                <div className="permission-custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="permissionLabel">
                      Created By<span className="d-md-none">:</span>
                    </span>
                    <span className="permissionValue">
                      {" "}
                      <td>{roleById?.created_by?.split(" - ")[0]}</td>
                    </span>
                  </div>
                </div>
                <div className="permission-custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="permissionLabel">
                      Created At<span className="d-md-none">:</span>
                    </span>
                    <span className="permissionValue">
                      {" "}
                      {moment(roleById?.created_at).format("D MMM YYYY")}
                    </span>
                  </div>
                </div>
                <div className="permission-custom-box-value pb-0 border-bottom-0">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="permissionLabel">
                      Permissions<span className="d-md-none">:</span>
                    </span>
                    <ul style={{ fontWeight: "500", paddingLeft: "1.5rem" }}>
                      {roleById?.permissions?.length > 0 ? (
                        Object.entries(
                          roleById.permissions.reduce((acc, curr) => {
                            const [entity, action] =
                              curr.name.split(/_(?=[^_]+$)/);
                            if (!acc[entity]) acc[entity] = [];
                            acc[entity].push(action);
                            return acc;
                          }, {})
                        ).map(([entity, actions]) => (
                          <li key={entity}>
                            {entity
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (char) => char.toUpperCase())}
                            :{" "}
                            {actions
                              .map(
                                (action) =>
                                  action.charAt(0).toUpperCase() +
                                  action.slice(1).toLowerCase()
                              )
                              .join(", ")}
                          </li>
                        ))
                      ) : (
                        <li>No permissions</li>
                      )}
                    </ul>
                  </div>
                </div>
              </Row>
            </div>
          </TripModal>

          <DeleteModal
            show={deleteRoleModal}
            loading={loading.delete}
            onDeleteClick={async () => {
              handleDelete();
            }}
            onCloseClick={toggleDeleteRoleModal}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserPermissions;
